export const TenantCard = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  OrgInitial: {
    text: (el, s) => s.orgInitial || 'D',
    width: 'C',
    height: 'C',
    round: 'D',
    background: 'teal',
    color: 'white',
    fontWeight: '700',
    fontSize: 'A',
    flow: 'x',
    align: 'center center',
    flexShrink: '0'
  },
  Info: {
    flow: 'y',
    gap: 'W',
    flex: '1',
    OrgName: { text: (el, s) => s.orgName || 'Dental Org', fontSize: 'A', fontWeight: '600', color: 'inkText' },
    ClinicCount: { text: (el, s) => (s.clinicCount || '0') + ' clinics', fontSize: 'Z', color: 'inkMuted' }
  },
  RightSection: {
    flow: 'y',
    align: 'flex-end center',
    gap: 'Y',
    PlanBadge: {
      tag: 'span',
      text: (el, s) => s.plan || 'Enterprise',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: 'gold.15',
      color: 'gold'
    },
    StatusDot: {
      width: '10px',
      height: '10px',
      round: 'D',
      background: (el, s) => s.active !== false ? 'green' : 'red'
    }
  }
}
